import React, { useState, useEffect, useRef } from "react"
import { Row, Col, Card, CardBody, Input, Table, Button } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import ReactPaginate from "react-paginate"
import { Toaster } from "react-hot-toast"
import { CSVLink } from "react-csv"
import { addData } from "Servicescalls"

const Users = () => {
  const [User, setUser] = useState([])
  const [filteredUserData, setFilteredUserData] = useState([])
  const [search, setSearch] = useState({
    startDate: "",
    endDate: "",
    searchText: "",
  })
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)
  const csvLinkRef = useRef()

  useEffect(() => {
    GetAll()
  }, [])

  const GetAll = async () => {
    const dataArray = {
      paymentStatus: "All",
    }
    const response = await addData(
      "customer/getAllPaymentsAndOrders",
      dataArray
    )
    const _data = response
    setUser(_data.data.orders)
    setFilteredUserData(_data.data.orders)
  }

  const applyDateFilter = (data, start, end) => {
    if (!start || !end) {
      setFilteredUserData(data)
      return
    }
    const filtered = data.filter(item => {
      const itemDate = new Date(item.logCreatedDate).toISOString().slice(0, 10)
      return itemDate >= start && itemDate <= end
    })
    setFilteredUserData(filtered)
    setPageNumber(0)
  }

  const searchAll = async e => {
    const newSearch = { ...search, searchText: e.target.value }
    setSearch(newSearch)

    const dataArray = {
      paymentStatus: "All",
    }
    const response = await addData(
      "customer/getAllPaymentsAndOrders?searchQuery=" + e.target.value,
      dataArray
    )
    const _data = response
    setUser(_data.data.orders)
    applyDateFilter(_data.data.orders, newSearch.startDate, newSearch.endDate)
  }

  const handleDateChange = e => {
    const { name, value } = e.target
    const updatedSearch = { ...search, [name]: value }
    setSearch(updatedSearch)
    applyDateFilter(User, updatedSearch.startDate, updatedSearch.endDate)
  }

  const handleExcelDownload = () => {
    setSearch(prev => ({
      ...prev,
      startDate: "",
      endDate: "",
    }))
    setFilteredUserData(User)
    setPageNumber(0)
  }

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const pageCount = Math.ceil(filteredUserData.length / listPerPage)
  const dataToDisplay = filteredUserData.slice(
    pageNumber * listPerPage,
    pageNumber * listPerPage + listPerPage
  )

  const headers2 = [
    { label: "S.No", key: "sno" },
    { label: "Booking Id", key: "bookingId" },
    { label: "User Name", key: "name" },
    { label: "Phone Number", key: "phone" },
    { label: "Total Amount", key: "totalPrice" },
    { label: "Payment Type", key: "paymentMethod" },
    { label: "Transaction Id", key: "transactionId" },
    { label: "Status", key: "paymentStatus" },
  ]

  const csvData = filteredUserData.map((elt, i) => ({
    sno: i + 1,
    bookingId: elt.bookingId,
    name: elt.name,
    phone: elt.phone,
    totalPrice: elt.totalPrice,
    paymentMethod: elt.paymentMethod,
    transactionId: elt.transactionId,
    paymentStatus: elt.paymentStatus,
  }))

  const csvReport = {
    filename: "BookingReport.csv",
    headers: headers2,
    data: csvData,
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Hasini Enterprises"
            breadcrumbItem="Payment Report"
          />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row className="mb-3 align-items-end">
                    <Col md={8} className="d-flex align-items-center gap-2">
                      <Input
                        type="date"
                        name="startDate"
                        value={search.startDate}
                        onChange={handleDateChange}
                        style={{ maxWidth: "150px" }}
                      />
                      <Input
                        type="date"
                        name="endDate"
                        value={search.endDate}
                        onChange={handleDateChange}
                        style={{ maxWidth: "150px" }}
                      />
                      <CSVLink
                        {...csvReport}
                        filename="BookingReport.csv"
                        className="d-none"
                        ref={csvLinkRef}
                      />
                      <Button
                        className="btn btn-success"
                        type="button"
                        size="sm"
                        disabled={
                          search.startDate !== "" && search.endDate === ""
                        }
                        onClick={() => {
                          csvLinkRef.current.link.click()
                          handleExcelDownload()
                        }}
                      >
                        <i className="fas fa-file-excel"></i> Download Excel
                      </Button>
                    </Col>

                    <Col md={4} className="text-end">
                      <Input
                        type="text"
                        name="searchText"
                        value={search.searchText}
                        onChange={searchAll}
                        placeholder="Search.."
                        style={{ maxWidth: "250px", marginLeft: "auto" }}
                      />
                    </Col>
                  </Row>

                  <div className="table-rep-plugin mt-2">
                    <Table hover bordered responsive>
                      <thead>
                        <tr>
                          <th>Sl.No</th>
                          <th>Date</th>
                          <th>Booking Id</th>
                          <th>User Id</th>
                          <th>User Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Items</th>
                          <th>Total Amount</th>
                          <th>Payment Type</th>
                          <th>Transaction Id</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataToDisplay.map((data, key) => (
                          <tr key={key}>
                            <th scope="row">
                              {pageNumber * listPerPage + key + 1}
                            </th>
                            <td>{data.logCreatedDate.slice(0, 10)}</td>
                            <td>{data.bookingId}</td>
                            <td>{data.userId}</td>
                            <td>{data.name}</td>
                            <td>{data.email}</td>
                            <td>{data.phone}</td>
                            <td>
                              {data.items.map((item, i) => (
                                <p key={i}>
                                  {i + 1} {item.dishName}
                                </p>
                              ))}
                            </td>
                            <td>{data.totalPrice}</td>
                            <td>{data.paymentMethod}</td>
                            <td>{data.transactionId}</td>
                            <td>
                              <span className="badge bg-primary">
                                {data.paymentStatus}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                    <Col sm="12">
                      <div
                        className="d-flex mt-3 mb-1"
                        style={{ float: "right" }}
                      >
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                        />
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <Toaster />
      </div>
    </React.Fragment>
  )
}

export default Users